import {DeviceWithLocation} from '../interfaces/DeviceResponse';

interface GetSwitchURLProps {
  urlKey: string;
  selectedDevices: DeviceWithLocation[];
}

function getSwitchURL({urlKey, selectedDevices}: GetSwitchURLProps) {
  const uniqueSiteIds = Array.from(new Set(selectedDevices.map(device => device.siteId)))
    .filter(element => {
      return element !== undefined;
    })
    .map(siteId => 'siteId=' + siteId);

  const uniqueIdfs = Array.from(new Set(selectedDevices.map(device => device?.idf)))
    .filter(element => {
      return element !== undefined;
    })
    .map(idf => 'idf=' + idf);

  const uniqueDevices = Array.from(new Set(selectedDevices.map(device => device.deviceName)))
    .filter(element => {
      return element !== undefined;
    })
    .map(deviceName => 'deviceName=' + deviceName);

  const combinedParams = [...uniqueSiteIds, ...uniqueIdfs, ...uniqueDevices];

  return `/${urlKey}?${combinedParams.join('&')}`;
}

export default getSwitchURL;
